import { useState } from 'react';
import Layout from '@/components/layout/Layout';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { BulkStockCountTable } from '@/components/inventory/BulkStockCountTable';
import { StockCountHistory } from '@/components/inventory/StockCountHistory';

export default function InventoryStockCount() {
  const [activeTab, setActiveTab] = useState('record');

  return (
    <Layout>
      <div className="space-y-6">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Daily Stock Count</h1>
          <p className="text-muted-foreground">
            Record physical inventory counts and reconcile with system quantities
          </p>
        </div>

        <Tabs value={activeTab} onValueChange={setActiveTab}>
          <TabsList>
            <TabsTrigger value="record">Record</TabsTrigger>
            <TabsTrigger value="history">History</TabsTrigger>
          </TabsList>
          <TabsContent value="record">
            <BulkStockCountTable onSaveSuccess={() => setActiveTab('history')} />
          </TabsContent>
          <TabsContent value="history">
            <StockCountHistory />
          </TabsContent>
        </Tabs>
      </div>
    </Layout>
  );
}
